import * as Sentry from "@sentry/nextjs";
import { AxiosResponse } from "axios";
import { toast } from "react-toastify";

import { useErrorToaster } from "src/common/components/ErrorDetails";
import { client, endpoint, handleAllPromises } from "src/lib/bridgeClient";
import { SERVER_COMM_ERROR } from "src/lib/error";

export const deleteTemplateGroups = async (client: Client, templateGroupId: number) => {
  return await client(endpoint.deleteOrgWorkflowTemplateGroups(templateGroupId), "DELETE");
};

export const useDeleteTemplateGroup = () => {
  const toastError = useErrorToaster();

  return async (groups: WorkflowTemplateGroup[]) => {
    if (!groups) {
      return;
    }
    let responses: PromiseSettledResult<AxiosResponse>[];

    try {
      const promises = [];
      for (const group of groups) {
        promises.push(deleteTemplateGroups(client, group.id));
      }

      // Make all requests async and wait for all them to resolve
      responses = await Promise.allSettled(promises);
      const { failures } = handleAllPromises(responses);

      const apiErrors: string[] = [];
      for (const failure of failures) {
        if (failure.response.data?.error) {
          apiErrors.push(failure.response.data?.error);
        }
      }

      if (apiErrors.length > 0) {
        toastError("Failed to delete user groups to workflow templates", apiErrors);
      }

      const success = apiErrors?.length === 0;
      return { responses, success };
    } catch (error) {
      toast.error(`Request failed: ${SERVER_COMM_ERROR}`);
      Sentry.captureException(error);

      return error.response;
    }
  };
};
